// extracted by mini-css-extract-plugin
export default {"bg":"Footer_bg__rdzPH","base":"Footer_base__QkQ5C","content":"Footer_content__1dXVD","text":"Footer_text__Ygitu","line":"Footer_line__EUpJB"};